import React, { useEffect, useContext, useState, useRef } from "react";
import { Loading, useRedirect } from "react-admin";
import { useParams } from "react-router";
import { APIContext } from "../../store/APIStore";
import { StoreContext } from "../../store/Store";
import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
// import Typography from "@mui/material/Typography";
import { BiChevronDown, BiSearch, BiX } from "react-icons/bi";
import { BsPersonCheck, BsFileEarmarkCheck } from "react-icons/bs";
import ReservationsList from "./ReservationsList/ReservationsList";
import { routePaths } from "../../baseLayout/SidebarMenu";
import {
  DropdownButton,
  SimpleActionDialog,
} from "../../components";
import { Props as dialogType } from "./../../components/SimpleActionDialog/SimpleActionDialog";
import CSVUploadFlow from "../EventSessions/CSVUploadFlow/CSVUploadFlow";
import { dataType } from "../../components/GenericList/GenericList";
import NotificationMessage, {
  notificationType,
} from "../../components/NotificationMessage/NotificationMessage";
import { jobStatus } from "../../dataProvider/interfaces/IEvent";
import { PERMISSIONS } from "../../roles";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import IEventSession from "../../dataProvider/interfaces/IEventSession";
import ISessionReservation from "../../dataProvider/interfaces/ISessionReservation";
import { useLocation } from "react-router-dom";
import FdButton from "../../components/UIComponents/Button/FdButton";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import { reservationView as classes } from "./styles";
import TabContext from "@mui/lab/TabContext/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import CheckedInAttendee from "../CheckedInAttendees/CheckedInAttendees";
import Tooltip from "@mui/material/Tooltip";
import { FiLogOut } from "react-icons/fi";
import { RiGroupLine } from "react-icons/ri";

interface IProps{
  activeTab?:string;
}

const ReservationsView = ({activeTab = "1"}:IProps) => {
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);
  const { eventId, sessionId } = useParams() as any;
  const [loading, setLoading] = useState(true);
  const [viewDescription, setViewDescription] = useState(false);
  const [selectedSession, setSelectedSession] = useState<IEventSession>();
  const [searchKey, setSearchKey] = useState("");
  const redirect = useRedirect();
  const notificationRef = useRef<any>(); // notification bar
  const uploadDialogRef = useRef<any>(); // upload file dialog
  const searchRef = useRef<any>(); // search bar
  const location = useLocation().search;
  const [tabValue, setTabValue] = React.useState(activeTab);
  const [totalItems, setTotalItems] = useState(0)
  


  

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
    setTotalItems(0); //calculates on api response
    setSearchKey("");
    if (newValue === "2") {
      redirect(
        `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${sessionId}/${routePaths.SCANNED_IN_ATTENDEE}`
      );
    } else {
      fetchSessionReservations();
      redirect(
        `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${sessionId}/${routePaths.RESERVATIONS}`
      );
    }
  };
  const [confirmationDialog, setConfirmationDialog] = useState<dialogType>({
    open: false,
  });


  const handleDialogClose = () => {
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };

  // permissions
  const canManageReservation = useHasPermissions(
    PERMISSIONS.CAN_MANAGE_RESERVATION
  );

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setViewDescription(selectedSession?.description ? true : false)
  }, [selectedSession])

  const fetchData = () => {
    // check for search key and fetch reservations
    const search = new URLSearchParams(location).get("search");

    // fetch selected event
    if (eventId && !state.selectedEvent) {
      fetchSelectedEvent();
    }

    // fetch session details and reservations
    if (eventId && sessionId) {
      fetchSelectedSession();
      if (search) {
        setSearchKey(search);
        fetchSessionReservations(search);
      } else {
        fetchSessionReservations();
      }
    }
  };

  const fetchSelectedSession = async () => {
    const session = await api.sessionService.getSession(sessionId);
    setSelectedSession(session);
  };

  const fetchSelectedEvent = async () => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error);
    }
  };

  const fetchSessionReservations = async (keyword = "") => {
    try {
      setLoading(true);
      const reservations = await api.sessionService.getSessionReservations(
        sessionId,
        eventId
      );
      if (keyword.length > 0) {
        const filteredReservations = reservations.filter(
          (reservation: ISessionReservation) =>
            reservation.attendeeName &&
            reservation.attendeeName
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
        );
        setTotalItems(filteredReservations?.length || 0);
        dispatch({
          type: "SET_SESSION_RESERVATIONS",
          payload: filteredReservations,
        });
      } else {
        setTotalItems(reservations?.length || 0);
        dispatch({ type: "SET_SESSION_RESERVATIONS", payload: reservations });
      }
      setLoading(false);
    } catch (error: any) {
      console.log(error.response);
      setTotalItems(0);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleSearchKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      redirect(
        `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${sessionId}/${routePaths.RESERVATIONS}?search=${searchKey}`
      );

      // fetch reservations
      fetchSessionReservations(searchKey);
    }
  };

  const onSearchClick = (e: any) => {
    // fetch reservations
    redirect(
      `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${sessionId}/${routePaths.RESERVATIONS}?search=${searchKey}`
    );
    fetchSessionReservations(searchKey);
  };

  const handleSearchClear = () => {
    redirect(
      `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${sessionId}/${routePaths.RESERVATIONS}`
    );

    setSearchKey("");

    // fetch reservations
    fetchSessionReservations();
  };
  
  const handleClick = () => {
    setViewDescription(!viewDescription);
  };

  const handleNextSession = () =>{
    redirect(
      `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${selectedSession?.switchedToSessionId}/${routePaths.RESERVATIONS}`
    );
    window.location.reload();
  }
  useEffect(() => {
    const handlePopstate = () => {
      // This function is called when the user navigates back or forward.
      window.location.reload(); // Refresh the page
    };

    // Add a popstate event listener
    window.addEventListener('popstate', handlePopstate);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);
  return (
    <>
      <Box sx={classes.wrapper}>
        <Box sx={classes.contentWrapper} aria-label="contentWrapper">
          <Box sx={classes.topActions} aria-label="topActions">
            <Box sx={{maxWidth:"80%"}}>
              <FdTypography
                label={`${selectedSession?.name} - ${
                  tabValue === "1" ? "Reservations" : "Scanned in attendee"
                } `}
                component="h3"
                variant="h3"
              />
              <FdTypography
                variant="subtitle1"
                sx={classes.subtitleStyle}
                label={
                  <>
                    <RiGroupLine
                      style={classes.groupIcon}
                    />
                    Total {`${tabValue === "1" ? "Reservations" : "Scanned in attendee"}`}:
                    <Box component="span" fontWeight="bold" marginLeft={"5px"}>
                    {totalItems || 0}
                    </Box>
                  </>
                }
              />
              {selectedSession?.description && <FdButton
                variant="text"
                ButtonName={`${viewDescription ? "Hide" : "View"} description`}
                onClick={handleClick}
                sx={{ mt: 1 }}
              />}
            </Box>
<Box>
            {canManageReservation && (
              <DropdownButton
                label="Add reservations"
                endIcon={<BiChevronDown />}
                options={[
                  {
                    key: "single-reservation",
                    label: "Single reservation",
                    callback: () => {
                      redirect(
                        `/${routePaths.EVENTS}/${eventId}/${routePaths.SESSIONS}/${sessionId}/${routePaths.RESERVATIONS}/new`
                      );
                    },
                    startIcon: <BsPersonCheck fontSize="medium" />,
                  },
                  {
                    key: "upload-reservations",
                    label: "Upload reservations CSV",
                    callback: () => {
                      uploadDialogRef.current.openDialog();
                    },
                    startIcon: <BsFileEarmarkCheck fontSize="medium" />,
                  },
                ]}
              />
            )}
           {selectedSession?.switchedToSessionId !== null &&  
            <Tooltip title="This will take you to the next session that is at the same location" placement="left">
           <div><FdButton endIcon={<FiLogOut size="18" />} ButtonName="View next session"  onClick={handleNextSession} sx={{mt:2, fontWeight:"bold"}} /></div>
           </Tooltip>
           }
           </Box>
          </Box>
          {viewDescription && selectedSession?.description && (
            <Box sx={classes.descriptionBox}  aria-label="description-Box">
              <Box sx={classes.descriptionBoxInner}>
                  <Box style={{whiteSpace: 'pre-wrap'}}>{selectedSession?.description}</Box>
              </Box>
            </Box>
          )}

          {/* <Box aria-label="red"> */}
          {/* TAB */}
          <TabContext value={tabValue}>
            <Box>
              <TabList
                onChange={handleChange}
                aria-label="session sub list"
                sx={{
                  "& .MuiTab-root": {
                    textTransform: "capitalize",
                  },
                }}
              >
                <Tab label="Reservations" value="1" />
                <Tab label="Scanned In Attendee" value="2" />
              </TabList>
            </Box>

            <Box sx={classes.tabSection}>
              <TabPanel value="1">
                <Box
                  sx={classes.topFilters}
                  display="flex"
                  aria-label="topFilters"
                >
                  <FdTextField
                    id="searchInput"
                    sx={classes.searchInput}
                    placeholder="Search"
                    type="text"
                    inputRef={searchRef}
                    name="search"
                    onChange={(e) => {
                      const keyword = e.target.value;
                      setSearchKey(keyword);
                      if (keyword.length === 0) {
                        setSearchKey("");
                      }
                    }}
                    value={searchKey}
                    autoFocus
                    onKeyDown={handleSearchKeyDown}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BiSearch size="18" />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          sx={classes.clearIcon}
                          onClick={handleSearchClear}
                        >
                          {searchKey.length > 0 && <BiX size="20" />}
                        </InputAdornment>
                      ),
                    }}
                  />
                  <FdButton
                    variant="contained"
                    color="primary"
                    onClick={onSearchClick}
                    sx={classes.searchButton}
                    ButtonName="Search"
                  />
                </Box>
                {!loading && (
                  <Box sx={classes.listContent}>
                    <ReservationsList
                      reservations={state.sessionReservations}
                      eventId={eventId}
                      sessionId={sessionId}
                      onReservationListUpdate={(message: any, type: any) => {
                        if (message && type) {
                          notificationRef.current?.show(message, type);
                        }
                        fetchSessionReservations();
                      }}
                    />
                  </Box>
                )}
              </TabPanel>
              <TabPanel value="2">
                {!loading && <CheckedInAttendee setTotalItems={setTotalItems} />}
              </TabPanel>
            </Box>
          </TabContext>

          {/* </Box> */}

          {loading && <Loading />}
        </Box>
      </Box>

      <NotificationMessage ref={notificationRef} />

      <CSVUploadFlow
        ref={uploadDialogRef}
        type={dataType.RESERVATIONS}
        eventId={state.selectedEvent?.id}
        eventSessionId={sessionId}
        onCSVUpload={async (status: any, result: any) => {
          if (status === jobStatus.FINISHED) {
            await fetchSessionReservations();
            notificationRef.current?.show(result, notificationType.Success);
          }

          if (status === jobStatus.ERROR) {
            notificationRef.current?.show(result, notificationType.Error);
          }
        }}
      />
      {confirmationDialog.open && (
        <SimpleActionDialog
          type={confirmationDialog.type}
          icon={confirmationDialog.icon}
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          isLoading={confirmationDialog.isLoading}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          onClose={handleDialogClose}
          content={confirmationDialog.content}
          confirmLabel={confirmationDialog.confirmLabel}
          fullWidth={confirmationDialog.fullWidth}
        />
      )}
    </>
  );
};

export default ReservationsView;
